import { render, staticRenderFns } from "./GroupContact.vue?vue&type=template&id=176bfe58&scoped=true"
import script from "./GroupContact.vue?vue&type=script&lang=js"
export * from "./GroupContact.vue?vue&type=script&lang=js"
import style0 from "./GroupContact.vue?vue&type=style&index=0&id=176bfe58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176bfe58",
  null
  
)

export default component.exports